let items = document
    .querySelector(".header__inline-menu")
    .querySelectorAll("details");

for (const item of items) {
    let ul = item.querySelector("ul");

    // Aumentamos la zona de detección mediante padding extra en el borde inferior
    item.style.position = 'relative';  // Para ajustar la zona de detección
    item.style.zIndex = '10'; // Aseguramos que el detalle siempre esté encima

    // Ampliamos el área de detección con un padding en el borde inferior
    item.style.paddingBottom = '10px'; // Puedes ajustar este valor según lo necesites

    // Animación al pasar el ratón sobre el 'details'
    item.addEventListener("mouseenter", () => {
        ul.style.transition = "opacity 0.2s ease"; // Transición de 200ms para la opacidad
        ul.style.opacity = 0; // Inicialmente invisible
        ul.style.visibility = 'visible'; // Aseguramos que sea visible durante la animación

        // Forzamos el reflujo para reiniciar la animación
        void ul.offsetWidth;

        // Cambiamos la opacidad a 1 para hacer la animación
        ul.style.opacity = 1;
        item.setAttribute("open", true); // Marcamos el item como abierto
    });

    // Animación cuando el ratón sale del 'details'
    item.addEventListener("mouseleave", () => {
        let isMouseInside = ul.matches(':hover') || item.matches(':hover');

        if (!isMouseInside) {
            // Animamos el desvanecimiento y ocultamos el menú
            ul.style.transition = "opacity 0.05s ease"; // Transición de 50ms para la opacidad
            ul.style.opacity = 0;

            setTimeout(() => {
                ul.style.visibility = 'hidden'; // Lo ocultamos completamente después de la animación
                item.removeAttribute("open"); // Cerramos el item después de la animación
            }, 50); // La animación dura 50ms
        }
    });

    // Si el ratón sale del propio 'ul', cerramos el menú
    ul.addEventListener("mouseleave", () => {
        // Aseguramos que el ratón no salga accidentalmente del área activa
        let isMouseInside = item.matches(':hover') || ul.matches(':hover');

        if (!isMouseInside) {
            ul.style.transition = "opacity 0.05s ease"; // Transición de 50ms para la opacidad
            ul.style.opacity = 0;

            setTimeout(() => {
                ul.style.visibility = 'hidden'; // Lo ocultamos completamente después de la animación
                item.removeAttribute("open"); // Cerramos el item después de la animación
            }, 50); // La animación dura 50ms
        }
    });
}
